import gql from 'graphql-tag';
import { apollo } from 'src/features';

const mutation = gql`
mutation UpdateCaseComment($caseId: ID!, $comment: String!) {
  updateCaseComment(caseId: $caseId, comment: $comment) {
    comment
    id
    updatedAt
  }
}`;

function updateCaseComment(caseId, comment) {
  return apollo.client.mutate({
    mutation,
    variables: {
      caseId,
      comment,
    },
  }).then((res) => (res.data.updateCaseComment));
}

export default updateCaseComment;
